import { IShadows } from './IShadows';

const shadowValues = {
  shadowNativeValue: '0 2px 15px rgba(0,0,0,0.1)',
  shadowWebValue: '0 2px 15px 2px rgba(0,0,0,0.1)',
};

export const shadows: IShadows = {
  box: '0 2px 15px 0 rgba(0, 0, 0, 0.1)',
  ...shadowValues,
  shadowNative: `box-shadow: ${shadowValues.shadowNativeValue}; elevation: 10;`,
  shadowWeb: `box-shadow: ${shadowValues.shadowWebValue};`,
};
